/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomError,
    CustomErrorFromJSON,
    CustomErrorFromJSONTyped,
    CustomErrorToJSON,
    TokenDto,
    TokenDtoFromJSON,
    TokenDtoFromJSONTyped,
    TokenDtoToJSON,
} from './';

/**
 * The response with a objects of type "T".
 * @export
 * @interface TokenDtoResponseItemViewModel
 */
export interface TokenDtoResponseItemViewModel {
    /**
     * Gets the list of errors.
     * @type {Array<CustomError>}
     * @memberof TokenDtoResponseItemViewModel
     */
    readonly errors?: Array<CustomError> | null;
    /**
     * 
     * @type {TokenDto}
     * @memberof TokenDtoResponseItemViewModel
     */
    item?: TokenDto;
}

export function TokenDtoResponseItemViewModelFromJSON(json: any): TokenDtoResponseItemViewModel {
    return TokenDtoResponseItemViewModelFromJSONTyped(json, false);
}

export function TokenDtoResponseItemViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenDtoResponseItemViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(CustomErrorFromJSON)),
        'item': !exists(json, 'item') ? undefined : TokenDtoFromJSON(json['item']),
    };
}

export function TokenDtoResponseItemViewModelToJSON(value?: TokenDtoResponseItemViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item': TokenDtoToJSON(value.item),
    };
}


